import React from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Divider,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const OrderFilters = ({ open, onClose, filters, setFilters, onApply, onClear }) => {
  const handleChange = (section, key) => {
    setFilters((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [key]: !prev[section][key],
      },
    }));
  };

  const renderSection = (title, sectionKey, options) => (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
        {title}
      </Typography>
      <FormGroup>
        {options.map((opt) => (
          <FormControlLabel
            key={opt.key}
            control={
              <Checkbox
                checked={filters[sectionKey][opt.key]}
                onChange={() => handleChange(sectionKey, opt.key)}
              />
            }
            label={opt.label}
          />
        ))}
      </FormGroup>
      <Divider sx={{ my: 1 }} />
    </Box>
  );

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{ "& .MuiDrawer-paper": { width: 360, display: "flex", flexDirection: "column" } }}
    >
      {/* Header */}
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Filters
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />

      {/* Scrollable Content */}
      <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
        {renderSection("Order Status", "status", [
          { key: "ready", label: "Ready" },
          { key: "inProgress", label: "In Progress" },
          { key: "completed", label: "Completed" },
          { key: "cancelled", label: "Cancelled" },
        ])}

        {renderSection("Order Type", "orderType", [
          { key: "dineIn", label: "Dine In" },
          { key: "delivery", label: "Delivery" },
          { key: "takeAway", label: "Take Away" },
        ])}

        {renderSection("Dining Area", "diningArea", [
          { key: "garden", label: "Garden" },
          { key: "hall", label: "Hall" },
          { key: "rooftop", label: "Rooftop" },
          { key: "privateRoom", label: "Private Room" },
        ])}

        {renderSection("Payment Status", "paymentStatus", [
          { key: "paid", label: "Paid" },
          { key: "unpaid", label: "Unpaid" },
          { key: "partial", label: "Partial" },
        ])}
      </Box>

      {/* Fixed Footer */}
      <Box
        sx={{
          p: 2,
          borderTop: "1px solid #e0e0e0",
          display: "flex",
          gap: 2,
          bgcolor: "#fff",
        }}
      >
        <Button variant="outlined" fullWidth onClick={onClear}>
          Clear Filters
        </Button>
        <Button variant="contained" color="primary" fullWidth onClick={onApply}>
          Apply Filters
        </Button>
      </Box>
    </Drawer>
  );
};

export default OrderFilters;
